import React from 'react';

interface CategoryCardProps {
  title: string;
  subtitle: string;
  description: string;
  image: string;
  align: 'left' | 'right';
  onNavigate: (page: string) => void;
}

const CategoryCard: React.FC<CategoryCardProps> = ({ title, subtitle, description, image, align, onNavigate }) => {
  return (
    <div 
      className="relative group overflow-hidden h-[600px] w-full cursor-pointer"
      onClick={() => onNavigate('shop')}
    >
      {/* Background Image with Zoom Effect */}
      <img 
        src={image} 
        alt={title} 
        className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 transform group-hover:scale-110"
      />
      
      {/* Overlay - Darker gradient for better text readability */}
      <div className="absolute inset-0 bg-gradient-to-t from-stone-900/80 via-stone-900/20 to-transparent opacity-70 group-hover:opacity-90 transition-opacity duration-500"></div>

      {/* Content */}
      <div className={`absolute bottom-0 left-0 w-full p-12 flex flex-col ${align === 'right' ? 'items-end text-right' : 'items-start text-left'}`}>
        <span className="text-gold-300 text-xs tracking-[0.3em] uppercase mb-3 translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500 font-bold">
          {subtitle}
        </span>
        <h3 className="font-serif text-4xl text-white mb-4 drop-shadow-lg transform translate-y-0 transition-transform duration-500 group-hover:-translate-y-2">
          {title}
        </h3>
        <p className="text-white/90 text-sm font-light max-w-xs mb-8 opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-100 leading-relaxed shadow-sm">
          {description}
        </p>
        <button 
          onClick={(e) => { e.stopPropagation(); onNavigate('shop'); }}
          className="bg-transparent border border-white/70 text-white px-8 py-3 text-xs tracking-[0.2em] uppercase hover:bg-white hover:text-stone-900 transition-all duration-300 backdrop-blur-sm"
        >
          View Shop
        </button>
      </div>
    </div>
  );
};

interface GridCategoriesProps {
  onNavigate: (page: string) => void;
}

const GridCategories: React.FC<GridCategoriesProps> = ({ onNavigate }) => {
  return (
    <section className="grid grid-cols-1 md:grid-cols-2 bg-white">
      <CategoryCard 
        title="Wishlist for Her"
        subtitle="Timeless Beauty"
        description="Luxurious treasures for the modern woman. From diamonds to gold, find the perfect expression of love."
        // Updated Image: Woman wearing luxury jewelry
        image="https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?q=80&w=2070&auto=format&fit=crop"
        align="left"
        onNavigate={onNavigate}
      />
      <CategoryCard 
        title="Wishlist for Him"
        subtitle="Sophisticated Finds"
        description="Statement accessories for the discerning gentleman. Watches, cufflinks, and chains that define character."
        // Preserved Image: Man in suit
        image="https://images.unsplash.com/photo-1507679799987-c73779587ccf?q=80&w=2071&auto=format&fit=crop"
        align="right"
        onNavigate={onNavigate}
      />
    </section>
  );
};

export default GridCategories;